import { render, staticRenderFns } from "./tab-special.vue?vue&type=template&id=6a2c469e&scoped=true"
import script from "./tab-special.vue?vue&type=script&lang=js"
export * from "./tab-special.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c469e",
  null
  
)

export default component.exports